import Vue from 'vue'
import VueRouter from 'vue-router'



import DemandaSite from '../views/site/DemandaSite.vue'
import PoliticaPrivacidade from '../views/site/PoliticaPrivacidade.vue'


import Login from '../views/Login.vue'
import Perfil from '../views/Perfil.vue'














Vue.use(VueRouter)

const routes = [


  {
    path: '/login',
    name: 'Login',
    component: Login,
  }

  ,

  {
    path: '/demandaSite',
    name: 'DemandaSite',
    component: DemandaSite,
  }
   ,
  {
    path: '/perfil',
    name: 'Perfil',
    component: Perfil,
  }
  ,
  {
    path: '/politicaPrivacidade',
    name: 'PoliticaPrivacidade',
    component: PoliticaPrivacidade,
  }
 

]

const router = new VueRouter({
  mode: 'history', // IMPORTANT
  routes
})

export default router
